// Hari K:06-11-2023 :BT-119138:Funds View - funds modal - start
import { forwardRef, memo, useCallback, useEffect, useState } from 'react';
import {
  BzButton,
  BzLoader,
  BzModal,
  BzModalBody,
  BzModalHeader,
  BzTabsContainer,
  BzToolTip,
} from '../../components';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBankList,
  getFundTransferMappedProduct,
  getFundsReport,
  getMktAllowed,
  getPeridiocityWiseBalance,
  getPeridiocityWiseBalanceAndType,
  getPeriodicities,
  getUPIDetails,
  getproducteWiseBalance,
  nonBusinessDays,
  updateActiveMarket,
} from '../../redux/actions/funds';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import FundsBreakupModal from './FundsBreakupModal';
import TransactionModal from './TransactionModal';
import dayjs from 'dayjs';
import AddFundsModal from './AddFundsModal';
import { _commaFormatter, _kFormatter } from '../../controllers';
import MandateReportModal from './MandateReportModal';
import {
  API_CODES,
  APP_INFO_PARAMS,
  FUNDS,
  FUNDS_CONFIG_KEYS,
  LOCATIONS,
} from '../../utils/global_variables';
import TransferModal from './TransferModal';
import WithdrawModal from './WithdrawalModal';
import {
  checkFundsConfigConditions,
  getApiExchangeMktSegment,
  getAppInfoData,
  getDyanmicURL,
  isGuestUser,
  isUserIsAGuest,
  MY_SUMMARY_REF,
} from '../../utils/global_functions';
import MandateRegisterModal from './MandateRegisterModal';
import BankAvailableModal from './BankAvailableModal';
import { useLocation } from 'react-router';
import SuccessModal from './SuccessModal';
import FundsBody from './FundsBody';
import UtilisedAvailable from './UtilisedAvailable';
import ZeroStates from '../ZeroStates';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';

const Funds = ({ type }) => {
  const dispatch = useDispatch();
  const modals = useSelector((state) => state.modals.modals);
  const isPeriodicityWiseBalancePending = useSelector(
    (state) => state.funds.isPeriodicityWiseBalancePending
  );
  const productWiseBalance = useSelector(
    (state) => state.funds.productWiseBalance
  );
  const allowedMarkets = useSelector((state) => state.funds.allowedMarkets);
  const peridiocityWiseBalance = useSelector(
    (state) => state.funds.peridiocityWiseBalance
  );
  const objLoginSession = useSelector((state) => state?.auth?.objLoginSession);
  const withdrawalUrl = getAppInfoData(
    APP_INFO_PARAMS.APP_FUNDS_WITHDRAWAL_URL
  );


  const addFunds = getAppInfoData(APP_INFO_PARAMS.FUNDS_ADD);

  const data = getAppInfoData(APP_INFO_PARAMS.APP_FUNDS_CONFIG);
  const fundsConfig = Array.isArray(data) ? data[0] : data;
  const dicTrHolidayMaster = useSelector(
    (state) => state.funds.dicTrHolidayMaster
  );
  const bankAccList = useSelector((state) => state.funds.bankAccList);
  const periodicities = useSelector((state) => state.funds.periodicities);
  const objActiveMarket = useSelector((state) => state.funds.activeMarket);
  const location = useLocation();

  const [activePeriodiciti, setActivePeriodiciti] = useState({});
  const [startDate, setStartDate] = useState(dayjs().format('MM-DD-YYYY'));
  const [endDate, setEndDate] = useState(dayjs().format('MM-DD-YYYY'));
  const [activeMarket, setActiveMarket] = useState();
  const [arrActivePeriodicities, setArrActivePeriodicities] = useState();

  const getEvent = useAnalyticsEventTracker('FUNDS');
  // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration : Start
  const peridiocityWiseBalanceAndType = useSelector(
    (state) => state.funds.peridiocityWiseBalanceAndType
  );
  const [
    modifiedPerdiocityBalanceAndType,
    setModifiedPerdiocityWiseBalanceAndType,
  ] = useState({});

  const filterByPeriodicityId = (objMarket) => {
    if (peridiocityWiseBalance?.length > 0)
      return peridiocityWiseBalance.filter((each) =>
        objMarket?.periodicities?.includes(each?.id)
      );
    return false;
  };
  // Ravi R - BREEZE:367 :13/03/2025 Alternative Fund Summary based on Configuration : End
  const modalKey = modals['FUNDS_MODAL'];
  useEffect(() => {
    if (modalKey) {
      dispatch(getPeridiocityWiseBalance());
    }
  }, [modalKey]);

  useEffect(() => {
    if (allowedMarkets?.length > 0) {
      let selectedMarket = objActiveMarket === undefined ? allowedMarkets[0] : objActiveMarket;
      setActiveMarket(selectedMarket);
      if (peridiocityWiseBalanceAndType?.length === 0) {
        const periodicity = filterByPeriodicityId(selectedMarket);
        if (periodicity)
          dispatch(getPeridiocityWiseBalanceAndType(periodicity[0]?.id, 'BP'));
        // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration
        else
          setModifiedPerdiocityWiseBalanceAndType(
            modifyPerdiocityWiseBalanceAndType({})
          );
      }
    } else {
    }
  }, [allowedMarkets, peridiocityWiseBalance, objActiveMarket]);
  useEffect(() => {
    if (peridiocityWiseBalance?.length && allowedMarkets?.length) {
      const marketWisePeriodicities = peridiocityWiseBalance?.filter((each) =>
        activeMarket?.periodicities.includes(each.id)
      );
      setActivePeriodiciti(marketWisePeriodicities[0]);
      setArrActivePeriodicities(marketWisePeriodicities);
    } else {
    }
  }, [peridiocityWiseBalance, activeMarket, allowedMarkets]);

  useEffect(() => {
    if (fundsConfig?.newsummary && activePeriodiciti?.id)
      dispatch(getPeridiocityWiseBalanceAndType(activePeriodiciti?.id, 'BP'));
    // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration
    else
      setModifiedPerdiocityWiseBalanceAndType(
        modifyPerdiocityWiseBalanceAndType({})
      );
  }, [activePeriodiciti]);
  // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration : Start
  useEffect(() => {
    setModifiedPerdiocityWiseBalanceAndType(
      modifyPerdiocityWiseBalanceAndType(peridiocityWiseBalanceAndType)
    );
  }, [peridiocityWiseBalanceAndType]);
  // Ravi R - BREEZE:367 :13/03/2025 Alternative Fund Summary based on Configuration : End

  useEffect(() => {
    // Deepti B. 18/04/2024 Restricted API call on click of funds
    if (!isGuestUser()) {
      //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
      if (peridiocityWiseBalance?.length <= 0) {
        dispatch(getPeridiocityWiseBalance());
      } else {
      }
      if (
        productWiseBalance?.length <= 0 &&
        (location.pathname !== LOCATIONS.WATCHLIST ||
          location.pathname !== LOCATIONS.DASHBOARD)
      ) {
        dispatch(getproducteWiseBalance());
      } else {
      }
      dispatch(getPeriodicities());
      if (bankAccList?.length <= 0) {
        dispatch(getBankList());
      } else {
      }
      if (periodicities?.length <= 0) {
        dispatch(getUPIDetails());
      } else {
      }
      // {    /* Hari K:22-02-2023 :BT-119138:Funds View- to get non business dates -start*/ }
      if (dicTrHolidayMaster?.length <= 0) {
        dispatch(nonBusinessDays());
      } else {
      }
      // {    /* Hari K:22-02-2023 :BT-119138:Funds View- to get non business dates -start*/ }
    } else {
    } //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
  }, [dispatch]);

  // {    /* Hari K:26-04-2023 :BT-119138:Funds View-start*/ }
  useEffect(() => {
    if (!isGuestUser()) {
      if (allowedMarkets?.length <= 0 && Object.keys(objLoginSession)?.length) {
        dispatch(getMktAllowed(getApiExchangeMktSegment(objLoginSession?.data?.exchanges)));
      } else {
      }
    } else {
    }
  }, [objLoginSession]);
  // {    /* Hari K:26-04-2023 :BT-119138:Funds View-end*/ }

  const onHide = () => {
    dispatch(handleModal([{ FUNDS_MODAL: false }]));
  };

  const CustomDropdownToggle = forwardRef(
    ({ children, onClick }, ref) => (
      <div
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}
      </div>
    )
  );

  const handleFundsModalButton = (value) => {
    if (value === FUNDS.WITHDRAWAL_FUNDS) {
      // Hari K:07-12-2023 taking the value from global variable
      if (withdrawalUrl?.length) {
        let modifiedUrl = getDyanmicURL({ url: withdrawalUrl }, objLoginSession, true);
        window.open(modifiedUrl);
      } else {
        dispatch(handleModal([{ WITHDRAW_MODAL: true }]));
      }
    } else if (value === FUNDS.TRANSFER_FUNDS) {
      // Hari K:07-12-2023 taking the value from global variable
      dispatch(handleModal([{ TRANSFER_MODAL: true }]));
      dispatch(getFundTransferMappedProduct(activeMarket?.sProductId));
    } else if (value === FUNDS.ADD_FUNDS) {
      getEvent('FUND_ADD_BUTTON');
      if (addFunds?.length) {
        let modifiedUrl = getDyanmicURL({ url: addFunds }, objLoginSession, true);
        window.open(modifiedUrl);
      } else {
        dispatch(handleModal([{ ADD_FUNDS_MODAL: true }]));
      }
      // Hari K:07-12-2023 taking the value from global variable
    }
  };

  const handleReportDropDown = (value) => {
    if (value === FUNDS.MANDATE_REPORT) {
      dispatch(handleModal([{ MANDATE_REPORT_MODAL: true }]));
    } else if (value === FUNDS.REGISTER_MANDATE) {
      dispatch(handleModal([{ MANDATE_REGISTER_MODAL: true }]));
    }
    if (value === FUNDS.RECENT_TRANSACTIONS) {
      if (startDate && endDate) {
        dispatch(getFundsReport(startDate, endDate));
      } else {
      }
      dispatch(handleModal([{ TRANSACTION_MODAL: true }]));
    } else {
    }
  };

  const handlePeriodicityChanges = (product) => {
    setActivePeriodiciti(product);
  };

  const handleMarketSelection = (objMarket) => {
    const periodicities = filterByPeriodicityId(objMarket);
    setArrActivePeriodicities(periodicities);
    dispatch(updateActiveMarket(objMarket));
    setActiveMarket(objMarket);
  };

  const handleParticulars = (value) => {
    if (value !== undefined) {
      // Hari k:2023-12-20 added condition and dispatching modal data
      // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration : Start
      dispatch(
        handleModalData({
          activePeriodiciti: !fundsConfig?.newsummary
            ? activePeriodiciti
            : modifiedPerdiocityBalanceAndType,
          particularId: value.nId,
        })
      );
      // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration : End
      dispatch(handleModal([{ FUNDS_BREAKUP_MODAL: true }]));
    } else {
    }
  };
  const [isRefreshDisable, setIsRefreshDisable] = useState(false);
  const handleRefreshButton = async () => {
    await setIsRefreshDisable(true);
    if (!isGuestUser()) {
      await Promise.all([
        dispatch(getPeridiocityWiseBalance()),
        dispatch(getMktAllowed(getApiExchangeMktSegment(objLoginSession?.data?.exchanges))),
      ]);
      await setIsRefreshDisable(false);
    } else {
    }
  };

  // Ravi R - BREEZE:367 : 13/03/2025 Alternative Fund Summary based on Configuration : Start
  const handleFunds = () => {
    if (!isUserIsAGuest('Funds')) {
      dispatch(handleModal([{ FUNDS_MODAL: true }]));
    } else {
    }
  };
  const modifyPerdiocityWiseBalanceAndType = useCallback(
    (peridiocityWiseBalanceAndType) => {
      if (
        peridiocityWiseBalanceAndType?.code == API_CODES.ECODE_SUCCESS &&
        peridiocityWiseBalanceAndType?.data?.data
      )
        return {
          data: peridiocityWiseBalanceAndType?.data?.data.reduce(
            (acc, curr) => {
              if (curr.nId == 0) return acc;
              const obj = {
                nId: curr.nId,
                sDescription: curr.sName,
                nTrading: curr.nValue,
                data: [],
              };
              if (curr.sReferenceHeader === '') return [...acc, obj];
              else
                return acc.map((item) =>
                  curr.sReferenceHeader == item.sDescription
                    ? {
                      ...item,
                      data: [
                        ...acc.find(
                          (item) =>
                            curr.sReferenceHeader === item.sDescription
                        ).data,
                        obj,
                      ],
                    }
                    : item
                );
            },
            []
          ),
        };
      return {
        data: [
          'CASH DEPOSIT',
          'NON CASH DEPOSIT',
          'UTILISED LIMIT',
          'AVAILABLE MARGIN',
        ].map((item, i) => ({
          nId: i + 1,
          sDescription: item,
          nTrading: 0,
          data: [],
        })),
      };
    },
    [activeMarket]
  );

  const kORCommaFormatter = (value, type) => {
    try {
      if (type === 'both') {
        return (
          <>
            ₹{' '}
            {activePeriodiciti && Object.keys(activePeriodiciti)?.length == 0
              ? '00.00'
              : parseFloat(
                activePeriodiciti?.arrIndividualFundsItems?.[value]
                  ?.nTrading
              )
                ? _commaFormatter(
                  _kFormatter(
                    parseFloat(
                      activePeriodiciti?.arrIndividualFundsItems
                        ?.[value]?.nTrading
                    )
                  )
                )
                : '0.00'}
          </>
        );
      }
      else {
        return <>₹{' '}
          {activePeriodiciti && Object.keys(activePeriodiciti)?.length == 0
            ? '00.00'
            : parseFloat(
              activePeriodiciti?.arrIndividualFundsItems?.[value]
                ?.nTrading
            )
              ? _commaFormatter(
                parseFloat(
                  activePeriodiciti?.arrIndividualFundsItems?.[value]
                    ?.nTrading
                )
              )
              : '0.00'}</>
      }
    } catch (e) {
      return '0.00';
    }
  };
  // Ravi R - BREEZE:367 :13/03/2025 Alternative Fund Summary based on Configuration : End

  return (
    <>
      {
        {
          watchlist: (
            <div className="sticky-funds-height py-1">
              <BzTabsContainer>
                <FundsBody
                  CustomDropdownToggle={CustomDropdownToggle}
                  allowedMarkets={allowedMarkets}
                  isRefreshDisable={isRefreshDisable}
                  type={type}
                  fundsConfig={fundsConfig}
                  activeMarket={activeMarket}
                  handleFundsModalButton={handleFundsModalButton}
                  activePeriodiciti={activePeriodiciti}
                  arrActivePeriodicities={arrActivePeriodicities}
                  handlePeriodicityChanges={handlePeriodicityChanges}
                  handleParticulars={handleParticulars}
                  handleReportDropDown={handleReportDropDown}
                  handleMarketSelection={handleMarketSelection}
                  handleRefreshButton={handleRefreshButton}
                  modifiedPerdiocityBalanceAndType={
                    modifiedPerdiocityBalanceAndType
                  }
                  kORCommaFormatter={kORCommaFormatter}
                />
              </BzTabsContainer>
            </div>
          ),
          dashboard: (
            <Container fluid className="p-0" ref={MY_SUMMARY_REF}>
              <Row className="g-0 px-3 dashboard-cards-header align-items-center">
                <Col md={10} className="d-flex justify-content-start">
                  <div className="font-regular font-size6 color-text line-height-1" data-testid='Dashboard-available-funds'>
                    Available Funds / Limits
                  </div>
                </Col>
                <Col md={2} className="d-flex justify-content-end">
                  <BzToolTip placement="top" TooltipMsg="open funds page">
                    <div
                      data-testid='maximize-available-funds'
                      className="background-icon"
                      onClick={() => handleFunds()}
                    >
                      <div className="icon-16 icon-maximize icon-dark"></div>
                    </div>
                  </BzToolTip>
                </Col>
              </Row>
              <div className="dashboard-cards-container mt-4">
                {isPeriodicityWiseBalancePending ? (
                  <div className="zero-state-alerts zero-state-alerts-lg">
                    <BzLoader
                      spinner={isPeriodicityWiseBalancePending}
                      spinnerContent={'Fetching Details'}
                    />
                  </div>
                ) : (
                  <>
                    {Object.keys(activePeriodiciti ? activePeriodiciti : {})
                      ?.length ? (
                      <>
                        <Row className="g-0">
                          <Col md={12} className="d-flex justify-content-between mb-2">
                            <div className="d-flex add-funds-dropdown-wrapper">
                              <Dropdown data-testid='dashboard-funds-product-dropdown' >
                                <Dropdown.Toggle as={CustomDropdownToggle}>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div className="font-medium font-size3 color-text">
                                      {activeMarket?.sProductName
                                        ? activeMarket?.sProductName
                                        : '-'}
                                    </div>
                                    <div className="icon-20 icon-sort-down icon-dark ms-2"></div>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {allowedMarkets &&
                                    allowedMarkets?.length > 0 &&
                                    allowedMarkets?.map(
                                      (eachProduct, i) => (
                                        <Dropdown.Item
                                          data-testid={`dashboard-funds-product-dropdown-item${i}`}
                                          key={i}
                                          onClick={() => {
                                            handleMarketSelection(eachProduct);
                                          }}
                                          value={eachProduct.sProductId}
                                        >
                                          {eachProduct?.sProductName}
                                        </Dropdown.Item>
                                      )
                                    )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="d-flex add-funds-dropdown-wrapper">
                              <Dropdown data-testid='dashboard-funds-periodicity-dropdown'>
                                <Dropdown.Toggle as={CustomDropdownToggle}>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div className="font-medium font-size3 color-text">
                                      {activePeriodiciti?.name
                                        ? activePeriodiciti?.name
                                        : '-'}
                                    </div>
                                    <div className="icon-20 icon-sort-down icon-dark ms-2"></div>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {arrActivePeriodicities &&
                                    arrActivePeriodicities?.length > 0 &&
                                    arrActivePeriodicities?.map(
                                      (eachPeriodiciti, i) => (
                                        <Dropdown.Item
                                          data-testid={`dashboard-funds-periodicity-dropdown-item-${i}`}
                                          key={i}
                                          onClick={() => {
                                            handlePeriodicityChanges(eachPeriodiciti);
                                          }}
                                          value={eachPeriodiciti.id}
                                        >
                                          {eachPeriodiciti?.name}
                                        </Dropdown.Item>
                                      )
                                    )}
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </Col>
                        </Row>
                        <Row className="g-0 mb-2">
                          <Col className="d-flex justify-content-start">
                            <div className="font-medium font-size9 color-text">
                              {kORCommaFormatter('Total_Trading_Power_Limit', 'both')}
                            </div>
                          </Col>
                        </Row>
                        <Row className='g-0 mb-4'>
                          <Col md={12}>
                            <UtilisedAvailable
                              type={type}
                              activePeriodiciti={activePeriodiciti}
                              handleParticulars={handleParticulars}
                              kORCommaFormatter={kORCommaFormatter}
                            />
                          </Col>
                        </Row></>) : (
                      <div className="zero-state-alerts zero-state-alerts-sm">
                        <ZeroStates
                          subText=""
                          icon="icon-64 icon-nodata mb-3 mrgauto"
                        />
                        <div className="font-regular font-size2 color-nodata text-center">
                          Uh oh! Looks like we missed something.
                        </div>
                        <div className="font-regular font-size2 color-nodata text-center">
                          Let us fix the problem and get back to you soon.
                          Meanwhile try
                        </div>
                        <div className="font-regular font-size2 color-nodata text-center">
                          <span className="color-primary">
                            Refreshing the section
                          </span>{' '}
                          or come back later.
                        </div>
                        <div data-testid="dashboard-funds-refresh-button"
                          className="icon-16 icon-refresh icon-dark ms-2 text-center"
                          onClick={handleRefreshButton}
                        ></div>
                      </div>
                    )}
                    {allowedMarkets && allowedMarkets.length ? (< >
                      <Row className='g-0'>
                        <Col className='d-flex gap-2'>
                          {checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.WITHDRAW_FUNDS) && (
                            <BzButton
                              data-testid="dashboard-funds-withdraw-funds-button"
                              disabled={!checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.WITHDRAW_FUNDS)}
                              className="btn btn-sm btn-outline btn-block d-flex justify-content-center align-items-center gap-1"
                              onClick={() =>
                                handleFundsModalButton('withdraw')
                              }
                            >
                              <div className="icon-16 icon-withdraw-funds icon-primary"></div>
                              <span className='font-medium font-size1 text-nowrap'>Withdraw</span>
                            </BzButton>
                          )}
                          {checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.TRANSFER_FUNDS) && (
                            <BzButton
                              data-testid="dashboard-funds-transfer-funds-button"
                              disabled={!checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.TRANSFER_FUNDS)}
                              className="btn btn-sm btn-outline btn-block d-flex justify-content-center align-items-center gap-1"
                              onClick={() =>
                                handleFundsModalButton('transfer')
                              }
                            >
                              <div className="icon-16 icon-transfer-funds icon-primary"></div>
                              <span className='font-medium font-size1 text-nowrap'>Transfer</span>
                            </BzButton>
                          )}
                          {checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.ADD_FUNDS) && (
                            <BzButton
                              data-testid="dashboard-funds-add-funds-button"
                              disabled={!checkFundsConfigConditions(fundsConfig, FUNDS_CONFIG_KEYS.ADD_FUNDS)}
                              className="btn btn-sm btn-primary btn-block d-flex justify-content-center align-items-center gap-1"
                              onClick={() =>
                                handleFundsModalButton('add funds')
                              }
                            >
                              <div className="icon-16 icon-add-funds icon-light"></div>
                              <span className='font-medium font-size1 text-nowrap'>Add Funds</span>
                            </BzButton>
                          )}
                        </Col>
                      </Row>
                    </>) : null}
                  </>
                )}
              </div>
            </Container>
          ),
          header: (
            <>
              {/* SumitG-08-12-23 */}
              {modals['FUNDS_MODAL'] &&
                <BzModal show={modals['FUNDS_MODAL']} onHide={onHide} data-testid="funds-modal">
                  <BzModalHeader className="modaltabs-header">
                    <Container fluid className="p-0">
                      <Row className="g-0">
                        <Col
                          md={10}
                          className="d-flex justify-content-start align-self-center"
                        >
                          <div
                            data-testid="funds-modal-title"
                            className="font-medium font-size4 color-text"
                          >
                            Funds
                          </div>
                        </Col>
                        <Col
                          md={2}
                          className="d-flex justify-content-end align-self-center"
                        >
                          <div
                            data-testid="funds-modal-close-icon"
                            className="icon-16 icon-close icon-dark"
                            onClick={onHide}
                          ></div>
                        </Col>
                      </Row>
                    </Container>
                  </BzModalHeader>
                  <BzModalBody>
                    <FundsBody
                      CustomDropdownToggle={CustomDropdownToggle}
                      allowedMarkets={allowedMarkets}
                      isRefreshDisable={isRefreshDisable}
                      type={type}
                      fundsConfig={fundsConfig}
                      activeMarket={activeMarket}
                      handleFundsModalButton={handleFundsModalButton}
                      activePeriodiciti={activePeriodiciti}
                      arrActivePeriodicities={arrActivePeriodicities}
                      handlePeriodicityChanges={handlePeriodicityChanges}
                      handleParticulars={handleParticulars}
                      handleReportDropDown={handleReportDropDown}
                      handleMarketSelection={handleMarketSelection}
                      handleRefreshButton={handleRefreshButton}
                      modifiedPerdiocityBalanceAndType={
                        modifiedPerdiocityBalanceAndType
                      }
                      kORCommaFormatter={kORCommaFormatter}
                    />
                  </BzModalBody>
                </BzModal>}
              {modals['FUNDS_BREAKUP_MODAL'] && <FundsBreakupModal />}
              {modals['TRANSACTION_MODAL'] && <TransactionModal
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />}
              {modals['ADD_FUNDS_MODAL'] && <AddFundsModal
                activeMarket={activeMarket}
                setActiveMarket={setActiveMarket}
              />}
              {modals['TRANSFER_MODAL'] && <TransferModal
                activeMarket={activeMarket}
                setActiveMarket={setActiveMarket}
              />}
              {modals['MANDATE_REPORT_MODAL'] && <MandateReportModal />}
              {modals['MANDATE_REGISTER_MODAL'] && <MandateRegisterModal />}
              {modals['WITHDRAW_MODAL'] && <WithdrawModal
                activeMarket={activeMarket}
                setActiveMarket={setActiveMarket}
              />}
              {modals['BANK_AVAILABLE_MODAL'] && < BankAvailableModal />}
              {modals['SUCCESS_MODAL'] && <SuccessModal startDate={startDate} endDate={endDate} />}
            </>
          ),
        }[type]
      }

    </>
  );
};

export default memo(Funds);

// Hari K:06-11-2023 :BT-119138:Funds View - Funds modal - end
